<template>
    <div>
        <b-navbar v-if="isAuthenticated == true && manualPatientImportEnabled" toggleable="md" type="light" class="the-header-with-import">
            <b-navbar-toggle target="nav_collapse_with_import"></b-navbar-toggle>
            <b-navbar-brand href="#" class="logo-link"><img height="100%" :src="logoUrl"></b-navbar-brand>
            <b-collapse is-nav id="nav_collapse_with_import">
                <b-navbar-nav>
                    <template v-for="navItem in navItems">
                      <b-nav-item-dropdown v-if="navItem.subItems" :key="navItem.tabName" :text="navItem.name">
                        <b-dropdown-item v-for="dropdownNavItem in navItem.subItems" :key="dropdownNavItem.name" :to="dropdownNavItem.path">
                          {{ dropdownNavItem.name }}
                        </b-dropdown-item>
                      </b-nav-item-dropdown>
                      <router-link v-else :key="navItem.name" :to="navItem.path" class="nav-item nav-link" :class="{ 'active': isActive(navItem.tabName) }">{{ navItem.name }}</router-link>
                    </template>
                </b-navbar-nav>
                <b-navbar-nav class="ml-auto">
                    <b-form v-if="showPatientSearch" inline class="ml-4">
                        <b-input-group>
                    <vue-bootstrap-typeahead ref="typeahead"
                            :data="matchedPatients"
                            v-model="searchTerm"
                            :serializer="s => s.firstName + ' ' + s.lastName + '(' + s.patientIdFromOrg + ')'"
                            placeholder="Patient Search"
                            :max-matches="maxSearchResults"
                            @hit="viewPatient"
                    >
                      <template slot="suggestion" slot-scope="{ data }">
                            <strong>{{ data.firstName + ' ' + data.lastName }}</strong>&nbsp;<small>{{ data.patientIdFromOrg }}</small>
                        </template>
                    </vue-bootstrap-typeahead>
                            <b-input-group-append>
                                <b-button variant="outline-secondary"><font-awesome-icon icon="search"/></b-button>
                            </b-input-group-append>
                        </b-input-group>

                    </b-form>
                  <b-form v-if="manualPatientImportEnabled" inline class="ml-2">
                  <button type="button" class="btn btn-orange" @click.prevent="patientEmrSearch"><font-awesome-icon class="mr-2" icon="search"/>
                    EMR Patient Search
                  </button>
                  </b-form>
                    <b-nav-item-dropdown right>
                        <!-- Using button-content slot -->
                        <template slot="button-content">
                            <font-awesome-icon class="user-icon" size="2x" :icon="['far', 'user-circle']"/>
                        </template>
                        <b-dropdown-item v-show="isAdmin" @click.prevent="showingOrgPicker = true">Switch Organization</b-dropdown-item>
                        <b-dropdown-item @click.prevent="logoutUser()">Logout</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
      <b-navbar v-if="isAuthenticated == true && !manualPatientImportEnabled" toggleable="md" type="light" class="the-header">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-navbar-brand href="#" class="logo-link"><img height="100%" :src="logoUrl"></b-navbar-brand>
        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav>
            <template v-for="navItem in navItems">
              <b-nav-item-dropdown v-if="navItem.subItems" :key="navItem.tabName" :text="navItem.name">
                <b-dropdown-item v-for="dropdownNavItem in navItem.subItems" :key="dropdownNavItem.name" :to="dropdownNavItem.path">
                  {{ dropdownNavItem.name }}
                </b-dropdown-item>
              </b-nav-item-dropdown>
              <router-link v-else :key="navItem.name" :to="navItem.path" class="nav-item nav-link" :class="{ 'active': isActive(navItem.tabName) }">{{ navItem.name }}</router-link>
            </template>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-form v-if="showPatientSearch" inline class="ml-4">
              <b-input-group>
                <vue-bootstrap-typeahead ref="typeahead"
                                         :data="matchedPatients"
                                         v-model="searchTerm"
                                         :serializer="s => s.firstName + ' ' + s.lastName + '(' + s.patientIdFromOrg + ')'"
                                         placeholder="Patient Search"
                                         :max-matches="maxSearchResults"
                                         @hit="viewPatient"
                >
                  <template slot="suggestion" slot-scope="{ data }">
                    <strong>{{ data.firstName + ' ' + data.lastName }}</strong>&nbsp;<small>{{ data.patientIdFromOrg }}</small>
                  </template>
                </vue-bootstrap-typeahead>
                <b-input-group-append>
                  <b-button variant="outline-secondary"><font-awesome-icon icon="search"/></b-button>
                </b-input-group-append>
              </b-input-group>

            </b-form>
            <b-nav-item-dropdown right>
              <!-- Using button-content slot -->
              <template slot="button-content">
                <font-awesome-icon class="user-icon" size="2x" :icon="['far', 'user-circle']"/>
              </template>
              <b-dropdown-item v-show="isAdmin" @click.prevent="showingOrgPicker = true">Switch Organization</b-dropdown-item>
              <b-dropdown-item @click.prevent="logoutUser()">Logout</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
        <organization-picker :visible="showingOrgPicker" @update:visible="visible => showingOrgPicker = visible"></organization-picker>
    </div>
</template>

<script>
  import OrganizationPicker from './OrganizationPicker'
  import VueBootstrapTypeahead from './VueBootstrapTypeahead'
  import _ from 'lodash'
  import api from '../services/api'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'the-header',

    components: { OrganizationPicker, VueBootstrapTypeahead },

    mixins: [AnalyticsMixin],

    data () {
      return {
        user: this.$store.user,
        showDropdown: false,
        showingOrgPicker: false,
        searchTerm: '',
        matchedPatients: [],
        maxSearchResults: 50
      }
    },

    watch: {
      searchTerm: _.debounce(function (searchTerm) { this.searchPatients() }, 200)
    },

    computed: {
      logoUrl () {
        return this.$store.organization.logoUrl
      },

      email () {
        return this.$store.user.email
      },

      isAuthenticated () {
        return this.$store.isAuthenticated
      },

      isAdmin () {
        return this.$store.isAdmin
      },

      bundlesEnabled () {
        return this.$store.organization.bundlesEnabled
      },

      manualPatientImportEnabled () {
        return this.$store.organization.manualPatientImportEnabled
      },

      showPatientSearch () {
        const userRoles = this.$store.userRoles

        if (userRoles.includes('OrganizationAdmin') || userRoles.includes('OrganizationUser') || userRoles.includes('Admin')) {
          return true
        }

        return false
      },

      navItems () {
        const userRoles = this.$store.userRoles
        const items = []

        if (userRoles.includes('OrganizationAdmin') || userRoles.includes('OrganizationUser') || userRoles.includes('Admin')) {
          items.push({
            name: 'Patient Q',
            tabName: 'patient-queue',
            path: '/'
          })
          items.push({
            name: 'Appointments',
            tabName: 'visit-dropdown',
            subItems: [{
                         name: 'Upcoming',
                         tabName: 'drop-visits',
                         path: '/visits'
                       },
                       {
                         name: 'Insurance',
                         tabName: 'drop-visits',
                         path: '/insurance-verification'
                       }]
          })
          if (userRoles.includes('OrganizationUser') && !userRoles.includes('Admin') && !userRoles.includes('OrganizationAdmin')) {
            items.push({
              name: 'Estimates',
              tabName: 'estimates',
              path: '/estimates'
            })
          }
          if (userRoles.includes('OrganizationAdmin') || userRoles.includes('Admin')) {
            items.push({
              name: 'Estimates',
              tabName: 'estimate-dropdown',
              subItems: [{
                           name: 'Estimates',
                           tabName: 'drop-estimates',
                           path: '/estimates'
                         },
                         {
                           name: 'Estimate Templates',
                           tabName: 'drop-estimates',
                           path: '/estimate-templates'
                         },
                         {
                           name: 'Estimate Fees',
                           tabName: 'estimate-fees',
                           path: '/estimate-fees'
                         },
                         {
                           name: 'Estimate Facility Fees',
                           tabName: 'estimate-asc-fees',
                           path: '/estimate-asc-fees'
                         },
                         {
                           name: 'Allowable Fee Schedules',
                           tabName: 'allowable-fee-schedules',
                           path: '/allowable-fee-schedules'
                         },
                         {
                           name: 'Facility Fee Schedules',
                           tabName: 'asc-fee-schedules',
                           path: '/asc-fee-schedules'
                         }]
            })
          }
          if (this.bundlesEnabled) {
            items.push({
              name: 'Episodic',
              tabName: 'drop-episodic',
              subItems: [
                {
                  name: 'Episodic Candidates',
                  tabName: 'drop-episodic',
                  path: '/bundle-candidates'
                },
                {
                  name: 'Episodic Payments',
                  tabName: 'drop-episodic',
                  path: '/bundle-payments'
                },
                {
                  name: 'Episodic Library',
                  tabName: 'drop-episodic',
                  path: '/bundles'
                },
                {
                  name: 'Participating Providers',
                  tabName: 'drop-episodic',
                  path: '/payees'
                }]
            })
          }
          items.push({
            name: 'Analytics',
            tabName: 'analytics',
            path: '/analytics'
          })
        }

        if (userRoles.includes('OrganizationEmployerUser')) {
          items.push({
            name: 'Employer Dashboard',
            tabName: 'employer-dashboard',
            path: '/employer-dashboard'
          })
        }

        if (userRoles.includes('OrganizationEmployerUser')) {
          items.push({
            name: 'Episode Library',
            tabName: 'employer-episode-library',
            path: '/employer-episode-library'
          })
        }

        if (userRoles.includes('OrganizationPayee')) {
          items.push({
            name: 'Participating Provider Dashboard',
            tabName: 'payee-dashboard',
            path: '/payee-dashboard'
          })
        }

        if (userRoles.includes('OrganizationAdmin') || userRoles.includes('Admin')) {
          items.push({
            name: 'Admin',
            tabName: 'drop-admin',
            subItems: [{
                         name: 'Users',
                         tabName: 'drop-admin',
                         path: '/users'
                       },
                       {
                         name: 'Audit Logs',
                         tabName: 'drop-admin',
                         path: '/audit-logs'
                       },
                       {
                         name: 'Custom Notifications',
                         tabName: 'custom-notifications',
                         path: '/custom-notifications'
                       }
            ]
          })
        }
        return items
      }
    },

    methods: {
      searchPatients () {
        if (!this.searchTerm) {
          this.matchedPatients = []
          return
        }

        const parameters = {
          searchTerm: this.searchTerm,
          maxResults: this.maxSearchResults
        }

        api.post('/Dashboard/PatientSearch', parameters).then(response => {
          this.trackEvent('PatientSearch', 'Load', 'ResponseTime', response.config.requestDuration)
          this.matchedPatients = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to search patients: ' + error.message, error)
          }
        })
      },

      viewPatient (patient) {
        this.searchTerm = ''
        this.$refs.typeahead.inputValue = ''
        this.$router.push({ name: 'patient-detail', params: { id: patient.organizationPatientId } })
      },
      patientEmrSearch () {
        if (this.$route.name !== 'search-patient') {
          this.$router.push({ name: 'search-patient' })
        }
      },
      logoutUser () {
        this.showDropdown = false
        this.$store.logoutUser()
        this.$router.push('/login')
      },

      isActive (tab) {
        const aNames = ['analytics', 'analytic']
        const pqNames = ['patient-queue']
        const ivNames = ['insurance-verification']
        const vNames = ['visits', 'visit']
        const eNames = ['estimates', 'patient-estimate']
        const bundleNames = ['bundles']
        const bundlePaymentNames = ['bundle-payments']
        const payeeNames = ['payees']
        const employerNames = ['employer-dashboard']
        const payeeDashboardNames = ['payee-dashboard']
        if (tab === 'patient-queue') {
          return pqNames.includes(this.$route.name)
        } else if (tab === 'insurance-verification') {
          return ivNames.includes(this.$route.name)
        } else if (tab === 'visits') {
          return vNames.includes(this.$route.name)
        } else if (tab === 'estimates') {
          return eNames.includes(this.$route.name)
        } else if (tab === 'analytics') {
          return aNames.includes(this.$route.name)
        } else if (tab === 'bundles') {
          return bundleNames.includes(this.$route.name)
        } else if (tab === 'bundle-payments') {
          return bundlePaymentNames.includes(this.$route.name)
        } else if (tab === 'payees') {
          return payeeNames.includes(this.$route.name)
        } else if (tab === 'employer-dashboard') {
          return employerNames.includes(this.$route.name)
        } else if (tab === 'payee-dashboard') {
          return payeeDashboardNames.includes(this.$route.name)
        }

        return false
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .the-header {
        border-bottom: 1px solid #dee2e6;
        background-color: #f9f9f9;
        max-height: 70px;
    }
    .user-icon {
        color: rgba(0, 0, 0, 0.5);
        vertical-align: middle;
    }
    .logo-link {
        display: block;
        height: 60px;
    }
    .the-header-with-import {
      border-bottom: 1px solid #dee2e6;
      background-color: #f9f9f9;
      max-height: 1000px;
    }
    @media (max-width: 1200px) {
      #nav_collapse_with_import {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-content: flex-start;
      }
      .the-header-with-import {
        border-bottom: 1px solid #dee2e6;
        background-color: #f9f9f9;
        max-height: 1000px;
      }
    }
</style>
